export const orientationOptions = [
  { value: "All", label: "All" },
  { value: "portrait", label: "Portrait" },
  { value: "landscape", label: "Landscape" },
];

export const useOptions = [
  { value: "All", label: "All" },
  { value: "direct-mail", label: "Direct Mail" },
  { value: "flyering", label: "Flyering" },
  { value: "door-to-door", label: "Door-to-Door" },
];

export const industryOptions = [
  { value: "All", label: "All" },
  { value: "restaurant", label: "Restaurants" },
  { value: "food-beverage", label: "Food & Beverages" },
  { value: "retail", label: "Retail" },
  { value: "real-estate", label: "Real Estate" },
  { value: "apparel-fashion", label: "Apparel & Fashion" },
  { value: "mobility", label: "Mobility" },
  { value: "finance", label: "Finance" },
  { value: "entertainment", label: "Entertainment" },
];

export const flyerFormatOptions = [
  { value: "All", label: "All" },
  { value: "4x6", label: "4 x 6" },
  { value: "6.25x9", label: "6.25 x 9" },
  { value: "4.25x11", label: "4.25 x 11.6" },
  { value: "6.25x11", label: "6.25 x 11" },
  { value: "a4", label: "A4" },
  { value: "a5", label: "A5" },
  { value: "a6", label: "A6" },
  { value: "dl", label: "DL" },
  { value: "doorhanger", label: "Doorhanger" },
  { value: "tearaway", label: "Tearaway" },
  { value: "businesscard", label: "Businesscard" },
];

export const useCaseOptions = [
  { value: "brand-awareness", label: "Brand Awareness" },
  { value: "acquisition", label: "Acquisition" },
  { value: "lifecycle", label: "Lifecycle" },
  { value: "reactivation", label: "Reactivation" },
  { value: "retention", label: "Retention" },
];

// Promo offer type options
export const promoOfferTypeOptions = [
  { value: "dollar", label: "$ Promo Offer" },
  { value: "percentage", label: "% Promo Offer" },
];

// Promo frequency options
export const promoFrequencyOptions = [
  { value: "1-time", label: "1 Time Promo" },
  { value: "2-successive", label: "2 Successive Promo" },
  { value: "3-successive", label: "3 Successive Promo" },
  { value: "4-successive", label: "4 Successive Promo" },
  { value: "5-successive", label: "5 Successive Promo" },
  { value: "other", label: "Other" },
];

// Dollar amount options
export const dollarAmountOptions = [
  { value: "5", label: "$5 off" },
  { value: "10", label: "$10 off" },
  { value: "15", label: "$15 off" },
  { value: "20", label: "$20 off" },
  { value: "30", label: "$30 off" },
  { value: "other", label: "Other" },
];

// Percentage amount options
export const percentageAmountOptions = [
  { value: "5", label: "5% off" },
  { value: "10", label: "10% off" },
  { value: "15", label: "15% off" },
  { value: "20", label: "20% off" },
  { value: "50", label: "50% off" },
  { value: "other", label: "Other" },
];
